// extracted by mini-css-extract-plugin
module.exports = {"nav":"color-selector_nav__ruK2c","link":"color-selector_link__NRlgp productImageWrapper","active":"color-selector_active__s_2tB"};